import { InboxItemType } from '@seen/core/models/inbox'
import { StandardTask } from '@seen/core/models/tasks/standard/standardTask'
import type { NotificationItem } from '#src/hooks/useNotificationItems.ts'

export type InboxNotificationItemFilterFn = (item: NotificationItem) => boolean

export function createTaskFilter(
  states: { taskReferenceString: string; state: StandardTask['state'] }[]
): (item: NotificationItem) => boolean {
  return (item) =>
    states.some(
      (s) =>
        (item.data.type === InboxItemType.TaskAssigned ||
          item.data.type === InboxItemType.TaskDue ||
          item.data.type === InboxItemType.TaskNewComment) &&
        s.taskReferenceString === item.data.task.reference &&
        StandardTask.isCompletedOrCancelled(s.state)
    )
}
